import { getLocales } from 'assets/locales/Locale';
import { usePublicCreateClaimProvider } from '../Hooks';
import { formatFormPhone } from 'assets/utils/forms/formatFormPhone';
import FormWrapper from 'assets/components/inputs/wrappers/FormWrapper';
import TextInput from 'assets/components/inputs/text/TextInput';
import InputWrapper from 'assets/components/inputs/wrappers/InputWrapper';

export default function PublicCreateClaimContactInfo() {
  const { lang } = getLocales();
  const publicCreateClaim = usePublicCreateClaimProvider();

  const form = publicCreateClaim.form;

  return (
    <>
      <h2>{lang.clientInfo}</h2>
      <FormWrapper style={{ padding: '0 !important' }}>
        <InputWrapper>
          <TextInput
            name="contactName"
            label={lang.contactName}
            error={form.errors?.claim?.createdByPayee?.name}
            value={form.data?.claim?.createdByPayee?.name ?? ''}
            style={{ width: '100%' }}
            onChange={({ contactName }) => {
              form.merge({
                claim: {
                  createdByPayee: {
                    name: contactName,
                  },
                },
              });
            }}
          />
          <TextInput
            name="phoneNumber"
            label={lang.phoneNumber}
            error={form.errors?.claim?.createdByPayee?.phoneNumber}
            value={form.data?.claim?.createdByPayee?.phoneNumber ?? ''}
            style={{ width: '100%' }}
            onChange={({ phoneNumber }) => {
              form.merge({
                claim: {
                  createdByPayee: {
                    phoneNumber: formatFormPhone(form.data?.claim?.createdByPayee?.phoneNumber, phoneNumber),
                  },
                },
              });
            }}
          />
        </InputWrapper>
        <InputWrapper>
          <TextInput
            name="email"
            label={lang.email}
            error={form.errors?.claim?.createdByPayee?.email}
            value={form.data?.claim?.createdByPayee?.email ?? ''}
            style={{ width: '100%' }}
            onChange={({ email }) => {
              form.merge({
                claim: {
                  createdByPayee: {
                    email,
                  },
                },
              });
            }}
          />
          <div style={{ width: '100%' }} />
        </InputWrapper>
      </FormWrapper>
    </>
  );
}
